import React from 'react';
import { Box } from '@mui/material';

const CustomTab = ({ label, selected, onClick, backgroundColor, color }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        padding: '10px 20px',
        borderRadius: '10px',
        cursor: 'pointer',
        backgroundColor: selected ? (backgroundColor || '#007BFF') : 'transparent',
        color: color || 'white',
        fontFamily: 'Raleway, sans-serif',
        fontSize: '16px',
        textTransform: 'none',
        transition: 'none',  
      }}
    >
      {label}
    </Box>
  );
};

export default CustomTab;